import { COLORS } from 'src/theme/palette';
import { makeStyles } from 'src/utils/makeStyles';

const styles = makeStyles({
  emptyCellText: {
    color: COLORS.black40,
    fontSize: '16px',
  },
  expandedRow: {
    '&:hover': {
      backgroundColor: 'rgba(255, 145, 0, 0.05)',
      cursor: 'pointer',
    },
  },
  withBorder: {
    borderBottom: `1px solid ${COLORS.halfTransparentGray}`,
  },
  withoutBorder: {
    borderBottom: 'none',
  },
  wrapperRow: {
    position: 'relative',
  },
  wrapperCell: {
    padding: '0',
  },
  contentCell: {
    border: 'none',
  },
  subrowContentCell: {
    border: 'none!important',
    padding: '0!important',
  },
  tableWrapper: {
    position: 'relative',
  },
  pagination: {
    overflow: 'initial',
  },
  rowDefaultBackground: {
    backgroundColor: `${COLORS.white}!important`,
  },
  checkbox: {
    width: '32px',
  },
});

export default styles;
